import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurta",
    price: 6296,
    discount: "30% OFF",
    sellingPrice: 8995,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-black-printed-kurta.webp",
    color: "Black",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Men Printed T-shirt",
    price: 584,
    discount: "55% OFF",
    sellingPrice: 1299,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-black-printed-tshirt.webp",
    color: "Black",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Printed Pure Cotton T-shirt",
    price: 329,
    discount: "45% OFF",
    sellingPrice: 599,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/Roadster/roadster-blue-printed-tshirt.webp",
    color: "Blue",
    rating: 4.6,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Ethnic Motifs",
    price: 2339,
    discount: "40% OFF",
    sellingPrice: 3899,
    category: "Women",
    imgUrl:
      "./assets/productImages/Women/Neerus/neerus-black-printed-kurta.webp",
    color: "Black",
    rating: 3.9,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Pure Cotton T-shirt",
    price: 996,
    discount: "5% OFF",
    sellingPrice: 1049,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-black-tshirt.webp",
    color: "Black",
    rating: 4.7,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Printed Slim Fit Pure Cotton T-shirt",
    price: 539,
    discount: "40% OFF",
    sellingPrice: 899,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-black-printed-tshirt.webp",
    color: "Black",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurta Set",
    price: 979,
    discount: "65% OFF",
    sellingPrice: 2799,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-brown-kurta.webp",
    color: "Brown",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Plain Kurta",
    price: 2449,
    discount: "30% OFF",
    sellingPrice: 3499,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Neerus/neerus-gray-kurta.webp",
    color: "Gray",
    rating: 4.6,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Men Cotton Pure Cotton T-shirt",
    price: 219,
    discount: "45% OFF",
    sellingPrice: 399,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/Roadster/roadster-black-printed-tshirt.webp",
    color: "Black",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Yoke Design Kurta",
    price: 849,
    discount: "50% OFF",
    sellingPrice: 1699,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-dark-yellow-kurta.webp",
    color: "Yellow",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Slim Fit T-shirt",
    price: 999,
    discount: "50% OFF",
    sellingPrice: 1999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-blue-collar-tshirt.webp",
    color: "Blue",
    rating: 3.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Solid Polo Collar T-shirt",
    price: 1424,
    discount: "5% OFF",
    sellingPrice: 1499,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-green-collar-tshirt.webp",
    color: "Green",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Essentials Small Logo Cotton",
    price: 649,
    discount: "35% OFF",
    sellingPrice: 999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-blue-tshirt.webp",
    color: "Blue",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Essentials Small Logo Cotton",
    price: 649,
    discount: "35% OFF",
    sellingPrice: 999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-black-tshirt.webp",
    color: "Black",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Kurta with Churidar & Dupatta",
    price: 2499,
    discount: "50% OFF",
    sellingPrice: 4999,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-blue-kurta.webp",
    color: "Blue",
    rating: 3.9,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Self Design Welt Pocket T-shirt",
    price: 769,
    discount: "45% OFF",
    sellingPrice: 1399,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-gray-tshirt.webp",
    color: "Gray",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Printed Straight Kurta",
    price: 1599,
    discount: "50% OFF",
    sellingPrice: 3199,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-green-printed-kurta.webp",
    color: "Green",
    rating: 3.8,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurta",
    price: 3496,
    discount: "30% OFF",
    sellingPrice: 4995,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-gray-kurta.webp",
    color: "Gray",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Round Neck T-shirt",
    price: 996,
    discount: "5% OFF",
    sellingPrice: 1049,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-blue-tshirt.webp",
    color: "Blue",
    rating: 3.7,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Solid Round Neck T-shirt",
    price: 269,
    discount: "55% OFF",
    sellingPrice: 599,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Roadster/roadster-blue-tshirt.webp",
    color: "Blue",
    rating: 4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Embellished Kurta",
    price: 2449,
    discount: "30% OFF",
    sellingPrice: 3499,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Neerus/neerus-green-kurta.webp",
    color: "Green",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Solid Round Neck T-shirt",
    price: 719,
    discount: "40% OFF",
    sellingPrice: 1199,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-blue-tshirt.webp",
    color: "Blue",
    rating: 4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Men Slim Fit EverFresh T-shirt",
    price: 1034,
    discount: "55% OFF",
    sellingPrice: 2299,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-dark-red-tshirt.webp",
    color: "Red",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurta",
    price: 3496,
    discount: "30% OFF",
    sellingPrice: 4995,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-gray-printed-kurta.webp",
    color: "Gray",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Slim Fit T-shirt",
    price: 1279,
    discount: "20% OFF",
    sellingPrice: 1599,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/USpolo/uspolo-orange-collar-tshirt.webp",
    color: "Orange",
    rating: 3.7,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Ethnic Kurta",
    price: 809,
    discount: "55% OFF",
    sellingPrice: 1799,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-light-gray-kurta.webp",
    color: "Gray",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Men Cotton Pure Cotton T-shirt",
    price: 219,
    discount: "45% OFF",
    sellingPrice: 399,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Roadster/roadster-black-tshirt.webp",
    color: "Black",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Ethnic Kurta",
    price: 999,
    discount: "50% OFF",
    sellingPrice: 1999,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Neerus/neerus-red-kurta.webp",
    color: "Red",
    rating: 3.6,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Longline T-shirt with Raw Edge",
    price: 319,
    discount: "60% OFF",
    sellingPrice: 799,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Roadster/roadster-gray-tshirt.webp",
    color: "Gray",
    rating: 3.8,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Boxy Fit Self Design Pure Cotton T-shirt",
    price: 659,
    discount: "45% OFF",
    sellingPrice: 1199,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-green-tshirt.webp",
    color: "Green",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Embellished Kurta",
    price: 3849,
    discount: "30% OFF",
    sellingPrice: 5499,
    category: "Women",
    imgUrl:
      "./assets/productImages/Women/Neerus/neerus-green-printed-kurta.webp",
    color: "Green",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Embroidered Slim Fit T-shirt",
    price: 999,
    discount: "50% OFF",
    sellingPrice: 1999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-red-collar-tshirt.webp",
    color: "Red",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Men Brand Logo Printed T-shirt",
    price: 1034,
    discount: "55% OFF",
    sellingPrice: 2299,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-green-printed-tshirt.webp",
    color: "Green",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Striped Straight Kurta",
    price: 629,
    discount: "65% OFF",
    sellingPrice: 1799,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-pink-kurta.webp",
    color: "Pink",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Henley Neck Pure Cotton T-shirt",
    price: 399,
    discount: "60% OFF",
    sellingPrice: 999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Roadster/roadster-green-tshirt.webp",
    color: "Green",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurti",
    price: 2997,
    discount: "40% OFF",
    sellingPrice: 4995,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-yellow-kurta.webp",
    color: "Yellow",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Printed Slim Fit T-shirt",
    price: 659,
    discount: "45% OFF",
    sellingPrice: 1199,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-pink-tshirt.webp",
    color: "Pink",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Printed Straight Kurta",
    price: 549,
    discount: "65% OFF",
    sellingPrice: 1699,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-white-kurta.webp",
    color: "White",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Men All Over Pure Cotton T-shirt",
    price: 319,
    discount: "60% OFF",
    sellingPrice: 799,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/Roadster/roadster-red-printed-tshirt.webp",
    color: "Red",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Solid Polo Collar T-shirt",
    price: 999,
    discount: "50% OFF",
    sellingPrice: 1999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/USpolo/uspolo-white-collar-tshirt.webp",
    color: "White",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Solid Straight Kurta",
    price: 1299,
    discount: "50% OFF",
    sellingPrice: 2599,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-white-kurta.webp",
    color: "White",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Men Essential Slim Fit T-shirt",
    price: 524,
    discount: "65% OFF",
    sellingPrice: 1499,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-red-tshirt.webp",
    color: "Red",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Curl Edge Cotton T-shirt",
    price: 329,
    discount: "45% OFF",
    sellingPrice: 599,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Roadster/roadster-red-tshirt.webp",
    color: "Red",
    rating: 4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Floral Printed Kurta",
    price: 2449,
    discount: "30% OFF",
    sellingPrice: 3499,
    category: "Women",
    imgUrl:
      "./assets/productImages/Women/Neerus/neerus-white-printed-kurta.webp",
    color: "White",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Brand Logo Embroidery T-shirt",
    price: 649,
    discount: "35% OFF",
    sellingPrice: 999,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-green-tshirt.webp",
    color: "Green",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Ethnic Motifs Kurta",
    price: 3749,
    discount: "25% OFF",
    sellingPrice: 4999,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-red-kurta.webp",
    color: "Red",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Men Polo Collar Slim Fit T-shirt",
    price: 1199,
    discount: "20% OFF",
    sellingPrice: 1499,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/USpolo/uspolo-yellow-collar-tshirt.webp",
    color: "Yellow",
    rating: 4.6,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Solid Polo Pure Cotton T-shirt",
    price: 879,
    discount: "45% OFF",
    sellingPrice: 1599,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-red-collar-tshirt.webp",
    color: "Red",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Printed Kurti",
    price: 2449,
    discount: "30% OFF",
    sellingPrice: 3499,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-red-printed-kurta.webp",
    color: "Red",
    rating: 3.7,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Printed Pure Cotton T-shirt",
    price: 384,
    discount: "45% OFF",
    sellingPrice: 699,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/Roadster/roadster-white-printed-tshirt.webp",
    color: "White",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "x Minions Slim Fit T-shirt",
    price: 719,
    discount: "40% OFF",
    sellingPrice: 1199,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-white-tshirt.webp",
    color: "White",
    rating: 4.1,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Kurta Set",
    price: 6584,
    discount: "20% OFF",
    sellingPrice: 8230,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Neerus/neerus-yellow-kurta.webp",
    color: "Yellow",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Striped Straight Kurta",
    price: 764,
    discount: "55% OFF",
    sellingPrice: 1699,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-yellow-kurta.webp",
    color: "Yellow",
    rating: 3.8,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Puma",
    description: "Printed Round Neck Pure Cotton",
    price: 714,
    discount: "35% OFF",
    sellingPrice: 1099,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Puma/puma-white-printed-tshirt.webp",
    color: "White",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Dyed Slim Fit T-shirt",
    price: 714,
    discount: "45% OFF",
    sellingPrice: 1299,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-red-tshirt.webp",
    color: "Red",
    rating: 4.2,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "U.S. Polo Assn.",
    description: "Printed Round Neck T-shirt",
    price: 599,
    discount: "40% OFF",
    sellingPrice: 999,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/USpolo/uspolo-white-printed-tshirt.webp",
    color: "White",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Neerus",
    description: "Women Yoke Design Kurta",
    price: 1499,
    discount: "50% OFF",
    sellingPrice: 2999,
    category: "Women",
    imgUrl:
      "./assets/productImages/Women/Neerus/neerus-blue-printed-kurta.webp",
    color: "Blue",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Roadster",
    description: "Printed Round Neck Pure Cotton T-shirt",
    price: 319,
    discount: "60% OFF",
    sellingPrice: 799,
    category: "Men",
    imgUrl:
      "./assets/productImages/Men/Roadster/roadster-yellow-printed-tshirt.webp",
    color: "Yellow",
    rating: 4.4,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Biba",
    description: "Women Kurta with Palazzos",
    price: 2599,
    discount: "30% OFF",
    sellingPrice: 4995,
    category: "Women",
    imgUrl: "./assets/productImages/Women/Biba/biba-green-kurta.webp",
    color: "Green",
    rating: 4.5,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "Wrogn",
    description: "Slim Fit Round Neck T-shirt",
    price: 659,
    discount: "45% OFF",
    sellingPrice: 1199,
    category: "Men",
    imgUrl: "./assets/productImages/Men/Wrogn/wrogn-yellow-tshirt.webp",
    color: "Yellow",
    rating: 4.3,
    inStock: true,
  },
  {
    id: uuid(),
    brand: "W",
    description: "Women Floral Kurta",
    price: 1749,
    discount: "50% OFF",
    sellingPrice: 3499,
    category: "Women",
    imgUrl: "./assets/productImages/Women/W/w-pink-printed-kurta.webp",
    color: "Pink",
    rating: 4.1,
    inStock: true,
  },
];
